export default __webpack_public_path__ + "static/media/hht1_ep19_minisitcom_04.b2869e55.png";